import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import router from './router'

// 抑制 ResizeObserver 错误警告
const originalError = console.error
const originalWarn = console.warn

console.error = (...args) => {
  const message = args[0]?.toString() || ''
  if (message.includes('ResizeObserver')) {
    return
  }
  originalError.apply(console, args)
}

console.warn = (...args) => {
  const message = args[0]?.toString() || ''
  if (message.includes('ResizeObserver')) {
    return
  }
  originalWarn.apply(console, args)
}

// 处理全局错误事件 - 必须在捕获阶段处理
const errorHandler = (event) => {
  if (event.message && event.message.includes('ResizeObserver')) {
    event.preventDefault()
    event.stopImmediatePropagation()
    return false
  }
}

window.addEventListener('error', errorHandler, true)

// 处理未捕获的 Promise 拒绝
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.toString() || ''
  if (reason.includes('ResizeObserver')) {
    event.preventDefault()
    return false
  }
})

const app = createApp(App)

// Vue 错误处理配置
app.config.errorHandler = (err, instance, info) => {
  if (err && err.toString().includes('ResizeObserver')) {
    return
  }
  console.error('Vue Error:', err, info)
}

app.use(Antd)
app.use(router)
app.mount('#app')
